import type { User } from '@paintscout/api'
import React, { useRef } from 'react'
import { useCalendar } from '../CalendarContext'
import { CalendarEstimatorSelect } from '../../CalendarToolbar'

export default function SalesCalendarEstimatorSelect() {
  const { selectedUsers, setSelectedUsers, view, tab } = useCalendar()
  const selectedUsersBeforeClick = useRef<User[]>(selectedUsers)

  // Only month view supports multi-user selection; day & week are single-select.
  const supportsMultiSelect = view === 'month'

  const handleClick = (user: User, e: React.MouseEvent) => {
    if (e.detail === 1) {
      selectedUsersBeforeClick.current = selectedUsers
    }
    if (!supportsMultiSelect) {
      setSelectedUsers([user])
      return
    }
    if (selectedUsers.some((u) => u.user_id === user.user_id)) {
      setSelectedUsers(selectedUsers.filter((u) => u.user_id !== user.user_id))
    } else {
      setSelectedUsers([...selectedUsers, user])
    }
  }

  const handleDoubleClick = (allUsers: User[]) => {
    if (!supportsMultiSelect) return
    const allWereSelected = selectedUsersBeforeClick.current.length === allUsers.length
    setSelectedUsers(allWereSelected ? [] : allUsers)
  }

  return (
    <CalendarEstimatorSelect
      selectedUsers={selectedUsers}
      tab={tab}
      onClick={handleClick}
      onDoubleClick={handleDoubleClick}
    />
  )
}
